export default __webpack_public_path__ + "static/tatang-8a20fd78ca770f1981b6442f9b528383.jpeg";